// src/views/EcgView.tsx

// 心电图展示页面

import axios from 'axios'
import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'

import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import { NEW_RECORD_SYSTEM, ROLE } from '../services/Macro'
import { checker } from '../utils/Checker'
import EcgContent from '../components/EcgContent'
import { DataApi } from '../services/Api'
import { encrypUtil } from '../utils/EncrypUtil'
import { Page } from '../services/Page'

class EcgView extends React.Component<WithTranslation> {

    state = {
        loginName: '',
        samples: {},
    }

    content: any;

    onRef = (ref: any) => {
        this.content = ref
    }

    componentDidMount() {
        // const { t } = this.props
        console.log(`进入账号详情页面时的登录校验`)
        const callChecker = async () => {
            console.log(`数据校验`)
            let token = localStorage.getItem('token') || null
            let lang = localStorage.getItem('lang') || 'zh_CN'
            let roleStr = localStorage.getItem('role') || `${ROLE.SUPER}`
            let role = roleStr == `${ROLE.SUPER}` ? ROLE.SUPER : ROLE.USER
            let isLogin = await checker.checkLogin(role, Page.ecgShow)
            if (isLogin) {
                // 请求页面数据
                let startTime = new Date().getTime()
                let requestData: any = {
                    role: ROLE.SUPER,
                    token: token,
                    url: '100',
                    lang: lang.split('_')[0]
                }
                if (NEW_RECORD_SYSTEM) requestData.newRecord = true
                let params = await encrypUtil.encodeRequestRsa(requestData)
                const response = await axios.post(DataApi.GET_RECORD_CHART, params)
                let endTime = new Date().getTime()
                let retData = response.data.data
                console.log(`获取心电图数据:\n`, retData)
                console.log(`执行时间(ms):\n`, endTime - startTime)
                this.state.samples = retData
                this.setState({ samples: this.state.samples })
                // 调用一次 draw
                this.content.callDrawFromParent()
            }
        }
        callChecker()
    }

    changeLang = () => { }

    render() {
        const { t, i18n } = this.props
        return (
            <section className="body">
                <Header trans={t} i18n={i18n} loginName={this.state.loginName} changeLang={this.changeLang}></Header>
                <div className="inner-wrapper">
                    <Sidebar selectMenu="ecg" trans={t} />
                    <EcgContent trans={t} samples={this.state.samples} onRef={this.onRef} />
                </div>
            </section>
        )
    }

}
export const EcgPage = withTranslation()(EcgView)